import {getImagePathWithTheme, isDarkMode, sleep} from "@/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useState, useReducer, useRef} from "react";
import style from './index.module.less'
import HeadingTree from "../HeadingTree";
import HighlightBar from '../HighlightBar/HighlightBar'
import {
    FROM_DIALOG,
    FROM_JOURNAL,
    FROM_PAGE_CARD,
    FROM_RIGHT_SIDE,
    FROM_SIDEBAR_FOLD,
    PAGE_TITLE_MARGIN_TOP
} from "@/Const";
import {atom, useAtom} from "jotai";
import {isMac} from "@/Utility";

export const atomIsSideBarExpand = atom<any>(false);

const SideBarFold = forwardRef((props:{editor:any,from:any,onCollapseCallback:any,data:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onToggleBar:onToggleBar,
        onRefreshHighlight:onRefreshHighlight,
        onRemoveSelectedHighlight:onRemoveSelectedHighlight
    }))
    const {editor} = props;
    //0表示没有侧边栏，1表示未展开状态的侧边栏，2表示展开状态的侧边栏
    const [sideBarStatus, setSideBarStatus] = useState<any>(0);//useAtom(atomSideBarStatus);
    // true表示在highlight视图，false则表示在目录视图
    const [activeHighLightView, setActiveHighLightView] = useState<boolean>(true);
    const highlightBarRef = useRef(null);
    const [isSidebarExpand,setIsSidebarExpand] = useAtom(atomIsSideBarExpand);

    useEffect(()=>{
        if (props.onCollapseCallback){
            props.onCollapseCallback(sideBarStatus);
        }
        setIsSidebarExpand(sideBarStatus == 2);
    },[sideBarStatus])
    /**
     * 弹出关闭侧栏
     */
    const onToggleBar = ()=>{
        let nNewStatus = sideBarStatus;
        if (sideBarStatus != 2){
            nNewStatus = 2;
        }else{
            nNewStatus = 0;
        }
        setSideBarStatus(nNewStatus);

        const { highlightExist, headingExist } = detectHighlightAndHeading();
        if (headingExist) {
            setActiveHighLightView(false)
        }
        if (highlightExist) {
            setActiveHighLightView(true)
        }
    }

    const onRefreshHighlight = ()=>{
        highlightBarRef.current?.onRefreshHighlight();
    }

    /**
     * 移除当前选中的条目
     */
    const onRemoveSelectedHighlight = ()=>{
        return highlightBarRef.current?.onRemoveSelectedHighlight();
    }

    // 定义两个函数：检测highlight和heading(即目录)
    function detectHighlightAndHeading() {
        let highlightExist = false
        let headingExist = false
        editor?.state?.doc?.descendants((node, pos) => {
            if (node.type.name === 'heading') {
                headingExist = true
            }
            if (node?.marks.some(mark => mark.type.name === 'highlight')) {
                highlightExist = true;
            }
            if (node.attrs?.highlightImgUrl){
                highlightExist = true;
            }
        });
        return { highlightExist, headingExist }
    }
    function caculateSidebarStatus() {
        // const { highlightExist, headingExist } = detectHighlightAndHeading()
        // if (!highlightExist && !headingExist) {
        //     setSideBarStatus(0)
        // } else {
        //     setSideBarStatus((prevStatus) => {
        //         if (prevStatus === 0) {
        //             setActiveHighLightView(true);
        //             return 1;
        //         }
        //         return prevStatus;
        //     });
        // }
    }
    function getSidebarStyle() {
        let width
        let padding
        let background
        if (sideBarStatus === 0) {
            width = '0px'
            padding = '0px'
        } else if (sideBarStatus === 1) {
            width = '50px'
            //   padding='2px 19px'
            padding = '0px'
            background='transparent'
            
        } else {
            width = '250px'
            //   padding='2px 19px'
            padding = '0px'
            background='#f9f9f9'
        }

        return {
            width: width,
            padding: padding,
            backgroundColor:background
        };
    }

    useEffect(() => {

        if (props.data?.annoId){
            setActiveHighLightView(true)
            setSideBarStatus(2);
        }else{
            setActiveHighLightView(false)
            setSideBarStatus(0)
        }

        editor.on("selectionUpdate", caculateSidebarStatus)
        editor.on("update", caculateSidebarStatus)
        document.addEventListener('refreshSidebar', caculateSidebarStatus);
        document.addEventListener('highlightBar-expand', handleHighlightShow);
        return () => {
            editor?.off("selectionUpdate", caculateSidebarStatus)
            editor?.off("update", caculateSidebarStatus)
            document.removeEventListener('refreshSidebar', caculateSidebarStatus);
            document.removeEventListener('highlightBar-expand', handleHighlightShow);
        }
    }, [props.data])

    const handleHighlightShow = async (e) => {
        setSideBarStatus(2)
        setActiveHighLightView(true)
        await sleep(10)
        document.dispatchEvent(new CustomEvent('highlightBar-navigate', {
            detail: {
                id: e.detail.id
            },
        }))
    }


    const getMarginTop = ()=>{
        if (props.from == FROM_JOURNAL){
            return '14px'
        }else if (props.from == FROM_PAGE_CARD || props.from == FROM_DIALOG || props.from == FROM_RIGHT_SIDE){
            return '0px';
        }
        return '90px';
    }

    return (
        <div className={style.sideBarStyle} style={{/*width:width,*/position:'absolute',top:getMarginTop(),paddingRight:'0px',width:'100%',borderRight:`${props.from == FROM_DIALOG?0:1}px solid var(--line-color)`}}>
            {/*{sideBarStatus === 1 && (*/}
            {/*    <img*/}
            {/*        className="img-16 cursor-pointer"*/}
            {/*        style={{ margin: '15px 20px 15px auto'}}*/}
            {/*        src={getImagePathWithTheme("note_menu_head_collapse")}*/}
            {/*        onClick={() => setSideBarStatus(2)} // 点击后切换到展开状态*/}
            {/*    />*/}
            {/*)}*/}
            {sideBarStatus === 2 && (
                <div style={{ width: '100%', height: (props.from == FROM_DIALOG || props.from == FROM_RIGHT_SIDE)?'100%':(isMac()?'calc(100% - 46px)':'calc(100% - 48px)'),overflow:'hidden',display:'flex',flexDirection:'column'}}>
                    {/*<img*/}
                    {/*    className="img-16 cursor-pointer"*/}
                    {/*    style={{ margin: '15px 19px' }}*/}
                    {/*    src={getImagePathWithTheme("note_menu_head_expand")}*/}
                    {/*    onClick={() => setSideBarStatus(1)} // 点击后切换到未展开状态*/}
                    {/*/>*/}
                    <div className={style.content} style={{marginTop:`${PAGE_TITLE_MARGIN_TOP}px`}}>
                        <div className={style.controls}>
                            <div
                                className={activeHighLightView === true ? style.button : style.activeButton}
                                onClick={() => setActiveHighLightView(true)}
                            >
                                <img className={'img-32'} src={getImagePathWithTheme('card_header_tree.svg')}/>
                            </div>
                            <div
                                className={activeHighLightView === false ? style.button : style.activeButton}
                                onClick={() => setActiveHighLightView(false)}
                            >
                                <img className={'img-32'} src={getImagePathWithTheme('card_highlight.svg')}/>
                            </div>
                        </div>
                        {/* 视图区域 */}
                        <div className={style.view}>
                            {activeHighLightView === true && <HighlightBar ref={highlightBarRef} editor={editor} data={props.data}/>}
                            {activeHighLightView === false && <HeadingTree editor={editor} from={FROM_SIDEBAR_FOLD} data={props.data}/>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
})
export default SideBarFold